import React, { Suspense } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const SuspenseWrapper = ({ children, fallback }) => {
  const defaultFallback = (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="200px"
      flexDirection="column"
      gap={2}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.secondary">
        Loading...
      </Typography>
    </Box>
  );

  return (
    <Suspense fallback={fallback || defaultFallback}>
      {children}
    </Suspense>
  );
};

export default SuspenseWrapper; 